import { render, staticRenderFns } from "./ProductPropertiesModal.vue?vue&type=template&id=3ad06a8a&scoped=true&"
import script from "./ProductPropertiesModal.vue?vue&type=script&lang=js&"
export * from "./ProductPropertiesModal.vue?vue&type=script&lang=js&"
import style0 from "./ProductPropertiesModal.vue?vue&type=style&index=0&id=3ad06a8a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ad06a8a",
  null
  
)

export default component.exports